.root {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
}

.splitButton {
  display: flex;
  align-items: center;
  min-width: 0;
  border: 1px solid #e5e7eb;
  border-radius: 99999px;
  background: #fff;
}

.primaryLink {
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 0.375rem;
  color: inherit;
  text-decoration: none;
  border-radius: 99999px 0 0 99999px;
}

.primaryLink:hover,
.dropdownTrigger:hover,
.itemLink:hover {
  background: #f3f4f6;
}

.primaryLink:focus-visible,
.dropdownTrigger:focus-visible,
.itemLink:focus-visible {
  outline: 2px solid #2a8fe6;
  outline-offset: 2px;
}

.dropdownTrigger {
  display: grid;
  width: 2rem;
  align-self: stretch;
  flex-shrink: 0;
  place-items: center;
  border: 0;
  border-left: 1px solid #e5e7eb;
  border-radius: 0 99999px 99999px 0;
  background: transparent;
  color: #111827;
  cursor: pointer;
}

.dropdownTrigger::after {
  width: 0.45rem;
  height: 0.45rem;
  border-right: 1.5px solid currentColor;
  border-bottom: 1.5px solid currentColor;
  content: '';
  transform: translateY(-0.15rem) rotate(45deg);
}

.dropdownTrigger:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.institutionInfo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.institutionLogo {
  width: 24px;
  height: 24px;
  border-radius: 9999px;
  object-fit: cover;
  background: #f3f4f6;
  flex-shrink: 0;
}

.institutionName {
  font-size: 0.9rem;
  font-weight: 600;
  color: #111827;
}

.institutionNameTruncated {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 12rem;
}

.adminBadge {
  flex-shrink: 0;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  border: 1px solid #d1d5db;
  border-radius: 9999px;
  padding: 0.1rem 0.4rem;
  background: #f9fafb;
}

.panel {
  width: min(20rem, calc(100vw - 2rem));
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.08);
  z-index: 40;
  padding: 0.5rem;
  margin-top: 0.25rem;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 0.25rem;
}

.itemLink {
  width: 100%;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  color: inherit;
  text-decoration: none;
}
